export const flaggedGroupLabel = "NSrBUe";
export const unflaggedGroupLabel = "ivTEMb";
export const completedGroupLabel = "kbW3g";
export default {flaggedGroupLabel,unflaggedGroupLabel,completedGroupLabel};